import { NgModule } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { TypographyComponentModule } from '../typography/typography.module';
import { ButtonComponentModule } from '../button/button-component.module';

@NgModule({
  declarations: [ConfirmDialogComponent],
  imports: [
    ConfirmDialogModule,
    TypographyComponentModule,
    ButtonComponentModule,
  ],
  exports: [ConfirmDialogComponent],
})
export class ConfirmDialogComponentModule {}
